import Cookies from 'universal-cookie';
import { decryptStorageData, encryptStorageData } from '../encryption/CryptoService';

const cookies = new Cookies();

export const createCookie = (props) => {
    let cookieValue = encryptStorageData(props.cookieValue);
    let cookieName = props.cookieName;
    cookies.set(cookieName, cookieValue,
        {
            path: props.path,
            maxAge: props.expirationTime * 60 * 60,
        });
};

//Store cookie
export const setCookie = (props) => {
    let cookieValue = encryptStorageData(props.cookieValue);
    let cookieName = props.cookieName;
    let options = props.options;
    cookies.set(cookieName, cookieValue, options);
}

export function getCookie(cookieName, doNotParse = false) {
    const cookieValue = cookies.get(cookieName, { doNotParse: doNotParse })
    return cookieValue ? decryptStorageData(cookieValue) : null;
}

export const getAllCookies = (doNotParse = false) => {
    const allCookies = cookies.getAll({ doNotParse: doNotParse });
    let decryptedCookies = {};
    Object.keys(allCookies).forEach((key) => {
        decryptedCookies[key] = decryptStorageData(allCookies[key]);
    });
    return decryptedCookies;
};

export const removeCookie = (cookieName, options = {}) => {
    cookies.remove(cookieName, options);
};

export const removeAllCookies = () => {
    const allCookies = cookies.getAll();
    Object.keys(allCookies).forEach((key) => {
        cookies.remove(key);
    });
};

//Check cookie exist or not
export const isCookieExist = (cookieName) => {
    const cookieDetail = getCookie(cookieName);
    return !!(cookieDetail);
}